import { render, staticRenderFns } from "./AthleteAccessControlFormSlim.vue?vue&type=template&id=7aed4298&scoped=true&"
import script from "./AthleteAccessControlFormSlim.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccessControlFormSlim.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAccessControlFormSlim.vue?vue&type=style&index=0&id=7aed4298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed4298",
  null
  
)

export default component.exports